import { render, staticRenderFns } from "./microphoneIcon.vue?vue&type=template&id=0f51e4e5&scoped=true"
import script from "./microphoneIcon.vue?vue&type=script&lang=js"
export * from "./microphoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51e4e5",
  null
  
)

export default component.exports